import { api, PartipostApiResponse } from './'
import { LoginResponse } from './profile'

export interface GoogleAuthExchangeRequest {
    temp_token: string
    redirectLink?: string | null
}

export const googleAuthExchange = (payload: GoogleAuthExchangeRequest) =>
    api.post<PartipostApiResponse<LoginResponse>>('auth/exchange-token/', { temp_token: payload.temp_token })
